import React from 'react';
import '../styles/takeawayLayout.css';

const TakeawayCategoryMenu = ({ categories, selected, onSelect, searchQuery, onSearchChange, halfAndHalfAvailable, onHalfNHalfClick }) => (
  <div className="categoryCol screenHeightCol-">
    <div className="sidebarSearchCol">
      <form className="formStyle searchStyle w-100" onSubmit={(e) => e.preventDefault()}>
        <svg width="17" height="18" className="searchIcon">
          <use xlinkHref="/images/sprite.svg#iconSearch"></use>
        </svg>
        <input
          type="text"
          className="form-control"
          placeholder="Search dishes (min 3 letters)"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </form>
    </div>
    <div className="sidebarTitleCol">
      <div className="row gx-2 align-items-center">
        <div className="col-auto titleIcon">
          <svg width="24" height="24" className="smTitleIcon primaryColor">
            <use href="/images/sprite.svg#iconCategoryIcon"></use>
          </svg>
        </div>
        <span className="col smTitle">Dishes Category</span>
      </div>
    </div>
    <ul className="categoryMenu">
      {halfAndHalfAvailable && (
        <li id="catid_half_and_half">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              onHalfNHalfClick();
            }}
          >
            Half n Half
          </a>
        </li>
      )}
      {categories.map((item, index) => (
        <li key={item.cuisine_id} id={`catid_${item.cuisine_id}`}>
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              onSelect(index);
            }}
            className={selected === index ? 'active' : ''}
          >
            {item.cuisine_name}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default TakeawayCategoryMenu;
